module.exports = __webpack_public_path__ + "static/media/Klavika_Regular.c394cc54.woff";